module.exports = __webpack_public_path__ + "img/ball_5_orange.b17116c5.png";